import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";

import { useStyles } from "./ViewFeeHead.css";
import { connect } from "react-redux";
import CustomTableHead from "../../../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import FeeHeadBody from "../FeeHeadBody/FeeHeadBody";
import AddFeeHead from "../AddFeeHead/AddFeeHead";
import { getAdminRefreshToken } from "../../../../../../Redux/Actions/actions";

class ViewFeeHead extends Component {
  constructor(props) {
    super(props);
    this.state = {
      column: [
        { name: "S.N." },
        { name: "Fee Head" },
        { name: "Price" },
        { name: "Actions" },
      ],
    };
  }

  render() {
    const { fees } = this.props;
    return (
      <div>
        <TableContainer>
          <Table>
            <CustomTableHead column={this.state.column} />
            <TableBody>
              <AddFeeHead
                groupId={this.props.groupId}
                getGroupDetails={this.props.getGroupDetails}
              />
            </TableBody>

            <TableBody>
              {fees.length !== 0 &&
                fees.map((fee, index) => (
                  <FeeHeadBody
                    key={index}
                    index={index}
                    data={fee}
                    groupId={this.props.groupId}
                    getGroupDetails={this.props.getGroupDetails}
                  />
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(ViewFeeHead));
